import {
  IBoxOnClickItem,
  IBuildInteractions,
  IWidgetInteraction,
} from '~types/clients/stores/home/breakpoint'
import { AnalyticsImageData } from '~types/index'

const buildInteractions = ({
  favoriteService,
  onClickProduct,
  onClickProductPromoTag,
  onAddProduct,
  onCarlessProduct,
  onInteractionProduct,
  onSeeMore,
  onClickSearch,
  buildListInfo,
  sendEventViewCategory,
  LinkSeeMore,
  onRedirect,
  onBannerClick,
  onBannerLoaded,
  onBeforeAddProduct,
}: IBuildInteractions): IWidgetInteraction => {
  return {
    imageCarrousel: {
      onClick: ({
        target,
        data,
      }: {
        target: string
        data: AnalyticsImageData
      }) => {
        if (target === 'image') {
          onBannerClick?.(data)
        }
      },
      onLoaded: ({
        target,
        data,
      }: {
        target: string
        data: AnalyticsImageData
      }) => {
        if (target === 'image') {
          onBannerLoaded?.(data)
        }
      },
    },
    isle: {
      trackSource: 'home',
      favoriteService,
      buildListInfo,
      LinkSeeMore,
      onSeeMore,
      onClickProduct,
      onClickProductPromoTag,
      onBeforeAddProduct,
      onAddProduct,
      onCarlessProduct,
      onInteractionProduct,
      onVisibleWidget: sendEventViewCategory,
    },
    box: {
      onClickItem: ({ source, ...boxData }: IBoxOnClickItem) => {
        if (source === 'category') {
          onSeeMore({ category: boxData })
          return
        }
        if (source === 'product') {
          onClickProduct({
            product: boxData,
            category: boxData.categories[0],
          })
          return
        }
        if (source === 'search') {
          onClickSearch(boxData)
          return
        }
        onRedirect(boxData)
      },
    },
  }
}

export default buildInteractions
